import { motion } from "framer-motion";
import type { ReactNode, CSSProperties } from "react";

export interface SwipeDismissTransitionProps {
  children: ReactNode;
  duration?: number;
  className?: string;
  style?: CSSProperties;
  "data-testid"?: string;
}

/**
 * List-item transition: collapses in on enter, swipes left and collapses on exit.
 * Must be used inside an `AnimatePresence` wrapper.
 */
const SwipeDismissTransition = ({
  children,
  duration = 0.25,
  className,
  style,
  "data-testid": dataTestId
}: SwipeDismissTransitionProps) => {
  return (
    <motion.div
      initial={{ height: 0 }}
      animate={{
        height: "auto",
        transition: { duration, ease: "easeInOut" }
      }}
      exit={{
        height: 0,
        transition: {
          duration: duration * 0.75,
          delay: duration * 0.7,
          ease: "easeInOut"
        }
      }}
      className={className}
      style={{ overflow: "hidden", ...style }}
      data-testid={dataTestId ?? "swipe-dismiss-transition"}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{
          opacity: 1,
          transition: { duration, ease: "easeInOut" }
        }}
        exit={{
          x: "-100%",
          opacity: 0,
          transition: { duration, ease: "easeIn" }
        }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
};

export default SwipeDismissTransition;
